import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Suppress i18next/Locize promotional message in console
const _log = console.log;
const _info = console.info;
console.log = function (...args) {
  if (args.length > 0 && typeof args[0] === 'string' && (args[0].includes('Locize') || args[0].includes('locize'))) return;
  return _log.apply(console, args);
};
console.info = function (...args) {
  const msg = args.length > 0 && typeof args[0] === 'string' ? args[0] : '';
  if (msg.includes('Locize') || msg.includes('locize') || msg.includes('powering your project')) return;
  return _info.apply(console, args);
};

import './i18n/config';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

reportWebVitals();

if (import.meta.hot) {
  import.meta.hot.accept('./i18n/config', async () => {
    await import('./i18n/config');
  });
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (import.meta.env.PROD) {
      const serviceWorkerVersion = 'v7';
      navigator.serviceWorker
        .register(`/sw.js?v=${serviceWorkerVersion}`)
        .catch((registrationError) => {
          console.error('SW registration failed: ', registrationError);
        });
      return;
    }

    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .then(() => {
        if ('caches' in window) {
          return caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
        }
        return null;
      })
      .catch(() => {
        // ignore SW cleanup errors in development
      });
  });
}
